import {
  cookieLogin,
  loginByIpApi,
  guestLogin,
  getUserInfo,
  netLogin
} from '@/apis/api'
// import { Message } from 'element-ui';
// import { createPinia, storeToRefs } from 'pinia';
import router from '../router';

import store from '@/store';
// 存取sessionStorage中的数据
function getItem(key) {
  let value = sessionStorage.getItem(key)
  return (typeof value === 'string') ? value : JSON.parse(value)
}
function setItem(key, value) {
  sessionStorage.setItem(key, (typeof value === 'string') ? value : JSON.stringify(value))
}

/* 
NetParams
http://192.168.1.140:8102/?n=xucy&s=28ba81d0be03a9412388575a08e955c2&t=dynamic_detail%3Fid%3D86d7941a-234c-4801-9c9b-df21c2278bfb
*/

// 自动登录入口函数--------------------入口函数-------------------------
async function myLogin() {
  // 居家办公临时改为true--实际为false
  store.commit('isCreatePage', false)
  const NetLoginParams = getNetParams()
  // console.log(NetLoginParams, 'NetLoginParams');
  if (JSON.stringify(NetLoginParams) === '{}') {
    //游客登录
    console.log('自动登录');
    await mainAutoLogin()
  } else {
    // 网络登录
    console.log('网络登录');
    await mainNetLogin(NetLoginParams)
  }
}
// ----------------------------游客登录/主函数--------------------------
async function mainAutoLogin() {
  if (getToken()) {
    //token存在
    // debugger
    await goGetUserInfo()
  } else {
    // token不存在
    await goAutoLogin()
  }
}
// -----------------------------网络登录/主函数--------------------------
async function mainNetLogin(NetLoginParams) {
  // console.log(NetLoginParams,'NetLoginParams')
  const { n, s, t } = NetLoginParams
  if (getToken()) {
    // token存在
    /* 先判断n与用户名是否相同
    相同---直接请求用户信息
    不同---执行网络登录 */
    if (n === getItem('netName')) {
      // 网络登录用户名之前已经登陆过
      /* 清除跳转地址 */
      NetLoginParams.t = ''
      setItem('NetParams', NetLoginParams)
      await goGetUserInfo()
    } else {
      await goNetLogin(NetLoginParams)
    }

  } else {
    // token不存在---直接进行网络登录
    await goNetLogin(NetLoginParams)
  }
}
// 获取网络登录参数---是否有n和s
function getNetParams() {
  const { search } = location
  let params = {}
  if (search) {
    // 有参数时---保存{n,s,t}或{}
    const queryArr = search.slice(1).split('&')
    queryArr.forEach(item => {
      let equalSignIndex = item.indexOf('=')
      let key, value
      key = item.slice(0, equalSignIndex)
      value = item.slice(equalSignIndex + 1)
      if (key === 'n' || key === 's' || key === 't') {
        params[key] = value
      }
    })
  } else {
    /* 没有参数时-----------------
    保存本地存储的参数{n,s,t}或{}
    */
    let NetParams = getItem('NetParams')
    params = NetParams ? JSON.parse(NetParams) : {}
  }
  return params
}
// 判断是否存在token
function getToken() {
  let token = getItem('token')
  return token
}
// 获取用户信息---获取用户信息失败--则调用公用自动登录
async function goGetUserInfo() {
  try {


    let userRes = await getUserInfo(false)
    // debugger
    if (userRes.success == false) {
      /* 获取用户信息失败，判断网络登录参数是否存在
      存在--网络登录
      失败--自动登录 */
      let NetParams = getNetParams()
      if (JSON.stringify(NetParams) !== '{}') {
        await goNetLogin(NetParams)
      } else {
        await goAutoLogin()
      }
      return
    }
    /* ------------------------------------这块存储用户信息数据（依据每个项目来）--------start-------------------- */
    store.commit('setUserInfo', userRes.data)
    /* ----------------------------------------存储数据--------------------end------------------------------ */
    // //必须手动调用，触发全局的plugins方法（各窗口间共享数据）
    /* localStorage.setItem("sessionStorage", JSON.stringify(sessionStorage));
    localStorage.setItem("changeSessionStorage", Date.now()); */
    localStorage.setItem("sessionStorage", JSON.stringify(sessionStorage));
    localStorage.removeItem("sessionStorage");
    //登录成功后再加载--控制内容区域是否创建
    store.commit('isCreatePage', true)
    // location.reload()
    let NetParams = getNetParams()
    if (JSON.stringify(NetParams) !== '{}') {
      const { t } = NetParams
      router.push(t ? decodeURIComponent(t) : '/')
      // 跳转后清除t的值
      NetParams.t = ''
      setItem('NetParams', NetParams)
    }
  } catch (error) {

  }
}

// 具体的自动登录--cookie ip guest--公用方法
async function goAutoLogin() {
  let res
  let isLogin = false
  try {



    res = await loginByIpApi()
    if (res.success) {
      setItem('token', res.data?.token || '')
      isLogin = true
    } /* else {
    res = await guestLogin()
    if (res.success) {
      setItem('token', res.data)
      isLogin = true
    }
    } */
  } catch (error) {

  }


  if (isLogin) {
    // Message.success(res.msg)
    // 游客登录成功---获取用户信息
    // 清除本地N和S
    sessionStorage.removeItem('NetParams')
    goGetUserInfo()
  } else {
    router.push('/login')
    store.commit('isCreatePage', true)
  }
}
// 具体的网络登录-------------------公用方法
async function goNetLogin(NetLoginParams) {
  console.log(NetLoginParams);
  const { n, s, t } = NetLoginParams
  let res = await netLogin(`n=${decodeURIComponent(n)}&s=${decodeURIComponent(s)}`)
  console.log(res, 'res');
  if (res.success) {
    // 网络登录成功--保存token，n,s + 获取用户信息
    setItem('token', res.data)
    setItem('NetParams', NetLoginParams)
    await goGetUserInfo()
  } else {
    // 网络登录失败
    /* 1.清除地址栏中参数
    2.去自动登录 */
    router.push('/')
    await goAutoLogin()
  }
}

export {
  myLogin, //全局公用判定网络登录或者游客登录的接口
  goGetUserInfo //获取用户信息，存储相关信息的接口
};